import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import HorizontalDivider from '../../../components_mobile/components/HorizontalDivider';
import withCountryCode from '../../../components/RoutesHoc/RoutesHoc';
import { RelatedProductsWrapper, SliderArrow, Title, ViewMore } from './RelatedProducts.css';
import RelatedProductLink from './RelatedProductLink';

const Carousel = dynamic(import('nuka-carousel'));

// TODO: refactor in functional component
class RelatedProducts extends Component {
  render() {
    const {
      currencySymbol,
      products,
      s3BasePath,
      showSale = false,
      brandUrl,
      brandName,
      department,
      buildUrlWithCountry,
    } = this.props;
    return (
      <RelatedProductsWrapper data-cy="products-related">
        <a id="more-brand-header" href={buildUrlWithCountry(brandUrl)}>
          <Title>More from {brandName}</Title>
        </a>
        <HorizontalDivider />
        <Carousel
          framePadding="0 50px"
          slidesToShow={4}
          slidesToScroll="auto"
          renderBottomCenterControls={null}
          wrapAround
          renderCenterLeftControls={({ previousSlide }) => (
            <SliderArrow onClick={previousSlide} className="icon-angle-left" />
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <SliderArrow onClick={nextSlide} className="icon-angle-right" />
          )}
        >
          {products.map(product => (
            <RelatedProductLink
              currencySymbol={currencySymbol}
              showSale={showSale}
              product={product}
              s3BasePath={s3BasePath}
            />
          ))}
          <a id="more-brand-carousel" href={buildUrlWithCountry(brandUrl)}>
            <ViewMore>
              View more from
              <span>{brandName}</span>
            </ViewMore>
          </a>
        </Carousel>
      </RelatedProductsWrapper>
    );
  }
}

RelatedProducts.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  brandUrl: PropTypes.string.isRequired,
  department: PropTypes.string,
  products: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
};

export default withCountryCode(RelatedProducts);
